import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import emailjs from 'emailjs-com';
import Navbar from "../../components/en/Navbar";
import Footer from "../../components/en/Footer";
import "../../styles/common.css";
import "../../styles/form.css";

const ContactEn = () => {
  const navigate = useNavigate();
  const form = useRef();

  const [formData, setFormData] = useState({
    inquiryType: '',
    company: '',
    name: '',
    email: '',
    message: '',
    privacy: false,
  });

  const [errorModal, setErrorModal] = useState({
    isOpen: false,
    message: ''
  });

  const [successModal, setSuccessModal] = useState({
    isOpen: false
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // 環境変数のチェック
    const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID;
    const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
    const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

    if (!serviceId || !templateId || !publicKey) {
      console.error('EmailJS environment variables are not set:', {
        serviceId: !!serviceId,
        templateId: !!templateId,
        publicKey: !!publicKey
      });
      setErrorModal({
        isOpen: true,
        message: 'Email configuration is not complete. Please contact the administrator.'
      });
      return;
    }

    emailjs.sendForm(serviceId, templateId, form.current, publicKey)
      .then((result) => {
        console.log('EmailJS send success:', result);
        console.log('Send result:', result.text);
        console.log('Status:', result.status);
        // フォームをリセット
        setFormData({
          inquiryType: '',
          company: '',
          name: '',
          email: '',
          message: '',
          privacy: false,
        });
        // 成功モーダルを表示
        console.log('Setting success modal to open');
        setSuccessModal({ isOpen: true });
        console.log('Success modal state should be updated');
        // モーダルが表示されたことを確認
        setTimeout(() => {
          console.log('After timeout - successModal.isOpen should be true');
        }, 100);
      }, (error) => {
        console.error('EmailJS send error:', error);
        console.error('Error details:', {
          status: error.status,
          text: error.text,
          message: error.message
        });
        const errorMessage = error.text || error.message || 'Unknown error';
        setErrorModal({
          isOpen: true,
          message: `Failed to send email.\n\nError: ${errorMessage}\n\nPlease try again or contact the administrator.`
        });
      });
  };

  const closeErrorModal = () => {
    setErrorModal({ isOpen: false, message: '' });
  };

  const closeSuccessModal = () => {
    setSuccessModal({ isOpen: false });
    navigate('/en');
  };

  // デバッグ用: モーダルの状態を確認
  useEffect(() => {
    console.log('successModal state changed:', successModal.isOpen);
  }, [successModal.isOpen]);

  useEffect(() => {
    console.log('errorModal state changed:', errorModal.isOpen);
  }, [errorModal.isOpen]);

  return (
    <>
      <Navbar />
      {errorModal.isOpen && (
        <div className="error-modal-overlay" onClick={closeErrorModal}>
          <div className="error-modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="error-modal-header">
              <h2>Error</h2>
              <button className="error-modal-close" onClick={closeErrorModal} aria-label="Close">
                ×
              </button>
            </div>
            <div className="error-modal-body">
              <p>{errorModal.message}</p>
            </div>
            <div className="error-modal-footer">
              <button className="button-black button-arrow" onClick={closeErrorModal}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}
      {successModal.isOpen && (
        <div className="error-modal-overlay" onClick={closeSuccessModal}>
          <div className="error-modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="error-modal-header">
              <h2>Submission Complete</h2>
              <button className="error-modal-close" onClick={closeSuccessModal} aria-label="Close">
                ×
              </button>
            </div>
            <div className="error-modal-body">
              <p>Thank you for contacting us.<br />Thank you for using our website.<br />After confirming the details of your inquiry, our representative will contact you.</p>
            </div>
            <div className="error-modal-footer">
              <button className="button-black button-arrow" onClick={closeSuccessModal}>
                Return to Home
              </button>
            </div>
          </div>
        </div>
      )}
      <main className='contact'>
        <section className='contact form'>
          <h1>Contact Us</h1>
          <p className='form-lead'>Consultations are free.<br />We welcome inquiries about website production, even if the specifications are not yet finalized.<br />In addition, you can also use this form to contact us regarding our printing services, such as original uniforms and novelty goods.</p>
          <div className='form-content'>
            <p className='form-explan'><span className='required'>*</span> indicates required fields. Please fill in the required fields and press the submit button.</p>
            <form ref={form} action='#' method='POST' id='contact-form' onSubmit={handleSubmit}>
              <div className='form-box'>
                <label htmlFor="inquiryType">Inquiry Type<span className='required'>*</span></label>
                <select
                  id="inquiryType"
                  name="inquiryType"
                  required
                  onChange={handleChange}
                  value={formData.inquiryType}
                >
                  <option value="">Please select</option>
                  <option value="Uniforms and custom printing, etc">Uniforms and custom printing, etc</option>
                  <option value="Web Development">Web Development</option>
                  <option value="Marketing Support">Marketing Support</option>
                  <option value="Branding & Cross-border Support">Branding & Cross-border Support</option>
                  <option value="Other">Other</option>
                </select>
              </div>
              <div className='form-box'>
                <label>Company Name</label>
                <input
                  type='text'
                  name='company'
                  placeholder='e.g., XYZ Corporation'
                  onChange={handleChange}
                  value={formData.company}
                />
              </div>
              <div className='form-box'>
                <label>Name<span className='required'>*</span></label>
                <input
                  type='text'
                  name='name'
                  placeholder='e.g., John Doe'
                  required
                  aria-required='true'
                  onChange={handleChange}
                  value={formData.name}
                />
              </div>
              <div className='form-box'>
                <label>Email Address<span className='required'>*</span></label>
                <input
                  type='email'
                  name='email'
                  placeholder='e.g., example@example.com'
                  required
                  aria-required='true'
                  onChange={handleChange}
                  value={formData.email}
                />
              </div>
              <div className='form-box'>
                <label>Message<span className='required'>*</span></label>
                <textarea
                  name='message'
                  placeholder='Please enter your message'
                  required
                  aria-required='true'
                  onChange={handleChange}
                  value={formData.message}
                ></textarea>
              </div>
              <div className='privacy-policy'>
                <label>
                  <input
                    type='checkbox'
                    name='privacy'
                    required
                    aria-required='true'
                    onChange={handleChange}
                    checked={formData.privacy}
                  />
                  <span className='privacy-policy__text'>
                    I agree to the <a href="/datenschutzerklarung" className='button-underLine'>Privacy Policy</a> and will submit<span className='required'>*</span>
                  </span>
                </label>
              </div>
              <div className='button-black button-arrow button-formSend'>
                <button type='submit' >Submit</button>
              </div>
            </form>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default ContactEn;
